import React, { useState , useEffect} from 'react';
import {
  Modal,
  Box,
  Select,
  MenuItem,
  Button,
  FormControl,
  TextField,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemSecondaryAction,
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const FieldValidValuesBuilder = ({
  isOpen,
  handleClose,
  onSubmit,
  initialValidValues,
}) => {
  const [validValues, setValidValues] = useState([]); // [{ VALUE: 'text' }]
  useEffect(() => {
    setValidValues(initialValidValues);
  }, 
  [isOpen,
  handleClose,
  onSubmit,
  initialValidValues]);

  // ✅ Add new value
  const handleAddValue = () => {
    setValidValues([...validValues, { VALUE: '' }]);
  };

  const handleUpdateValue = (index, newValue) => {
    const updated = [...validValues];
    updated[index].VALUE = newValue;
    setValidValues(updated);
  };

  const handleRemoveValue = (index) => {
    setValidValues(validValues.filter((_, i) => i !== index));
  };

  const moveUp = (index) => {
    if (index === 0) return;
    const updated = [...validValues];
    [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
    setValidValues(updated);
  };

  const moveDown = (index) => {
    if (index === validValues.length - 1) return;
    const updated = [...validValues];
    [updated[index + 1], updated[index]] = [updated[index], updated[index + 1]];
    setValidValues(updated);
  };

  const handleRemoveAll = () => {
    setValidValues([]);
  };

  const handleSave = () => {
    const payload = validValues;
    if (onSubmit) onSubmit(payload);
    handleClose();
  };

  const handleRemove = () => {
    const payload = [];
    if (onSubmit) onSubmit(payload);
    handleClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="field-valid-values-builder"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
          width: '500px',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          outline: 'none',
        }}
      >
        {/* HEADER */}
        <h3>Valid Values Config</h3>
        <hr />

        {/* SCROLLABLE CONTENT */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            pr: 1,
            mt: 0,
            mb: 2,
          }}
        >
          <List sx ={{p:0}}>
            {validValues.map((item, index) => (
              <ListItem key={index} sx={{ p: 0, mt: 1 }}>
                <TextField
                  value={item.VALUE}
                  onChange={(e) => handleUpdateValue(index, e.target.value)}
                  placeholder={`Value ${index + 1}`}
                  fullWidth
                  sx={{
                    mr: 1,
                    '& .MuiInputBase-root': {
                      height: 40,
                      backgroundColor: 'white',
                    },
                    '& .MuiOutlinedInput-input': {
                      height: 40,
                      width: '100%',
                    },
                  }}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    onClick={() => moveUp(index)}
                    disabled={index === 0}
                  >
                    <ArrowUpwardIcon
                      sx={{
                        color: 'var(--button-color)',
                        ':hover': { color: 'var(--button-hover-color)' },
                      }}
                    />
                  </IconButton>
                  <IconButton
                    edge="end"
                    onClick={() => moveDown(index)}
                    disabled={index === validValues.length - 1}
                  >
                    <ArrowDownwardIcon
                      sx={{
                        color: 'var(--button-color)',
                        ':hover': { color: 'var(--button-hover-color)' },
                      }}
                    />
                  </IconButton>
                  <IconButton
                    edge="end"
                    onClick={() => handleRemoveValue(index)}
                  >
                    <DeleteIcon
                      sx={{
                        color: 'var(--button-color-red)',
                        ':hover': {
                          color: 'var(--button-hover-color-red)',
                        },
                      }}
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>

        {/* ADD BUTTON */}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddValue}
          sx={{
            mb: 2,
            backgroundColor: 'var(--button-color)',
            color: 'white',
            textTransform: 'none',
            ':hover': { backgroundColor: 'var(--button-hover-color)' },
          }}
        >
          Add Value
        </Button>

        {/* FOOTER ACTIONS */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              backgroundColor: 'var(--button-color)',
              color: 'white',
              textTransform: 'none',
              ':hover': { backgroundColor: 'var(--button-hover-color)' },
            }}
          >
            Update
          </Button>

          <Button
            variant="contained"
            onClick={handleRemove}
            sx={{
              backgroundColor: 'var(--button-color-red)',
              color: 'white',
              textTransform: 'none',
              ':hover': { backgroundColor: 'var(--button-hover-color-red)' },
            }}
          >
            Remove 
          </Button>

        </Box>
      </Box>
    </Modal>
  );
};

export default FieldValidValuesBuilder;
